import React, { Component, PropTypes } from 'react';
import { FormControl, Button, OverlayTrigger } from 'react-bootstrap';
import { connect } from 'react-redux';
import DateTimeField from 'react-bootstrap-datetimepicker';
import _ from 'lodash';
import moment from 'moment';
import TimePicker from 'rc-time-picker';
import { Table, Tr, Td, Th, Thead } from 'reactable';
import clone from 'clone';
import { DragSource } from 'react-dnd';
import { createDragPreview } from 'react-dnd-text-dragpreview';

import getTooltip from '../../businessLogic/getTooltip.js';
import { gettext } from '../../i18n/service.js';
import getCurLang from '../../businessLogic/getCurLang.js';
import { firstToUpper } from '../../businessLogic/stringMethods.js';
import { getDashboardButtonStyle } from '../../businessLogic/getButtonStyle.js';
import * as Filters from '../../businessLogic/orderListFilters.js';
import formatCamelCase from '../../businessLogic/formatCamelCase.js';
import setOrderStatusColor from '../../businessLogic/setOrderStatusColor.js';
import { ItemTypes } from '../../constants/actionTypes';
import { columnsNewOrders, columnsProgress, columnsHistory } from '../../constants/orderListColumns';

import { getFilterOrdersForCompany } from '../../actions/onDemandActions.js';

import './OperatorOrdersListComponent.scss';
import '../../styles/dispatcherDashboardPageStyles.scss';
import './timepickerStyles.scss';
import * as appActions from "../../actions/appActions";
import {bindActionCreators} from "redux";


const dragPreviewStyle = {
  backgroundColor: '#60285E',
  color: 'white',
  fontSize: 15,
  paddingTop: 10,
  paddingRight: 10,
  paddingBottom: 10,
  paddingLeft: 10,
  opacity: 1
};

const orderSource = {
  beginDrag(props) {
    return {
      selectedOrders: props.selectedOrders,
    };
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}


function formatDragMessage(numOrders) {
  let num = 1;
  if(numOrders != 0)
    num = numOrders;
  const noun = num === 1 ? 'order' : 'orders';
  return `Moving ${num} ${noun}`;
}

export class OrdersList extends Component {
  constructor(props) {
    super(props);

    _.bindAll(this, ['handleVehicleFilterChange', 'handlePickUpTimeFilterChange', 'handleDeliveryTimeFilterChange', 'handleDateFilterChange',
                    'handleOrderTypeChange', 'handleOrderCostChange', 'handleOrderCashAmount', 'handleDispatcherChange',
                    'handleResetFilter', 'handleOrderIdChange', 'handleItemCount', 'handleOrderStatusChange', 'handleCreatedByChange',
                    'toggleOpenExpectedTime', 'toggleOpenDeliveryTime']);


    this.state = {
      openExpectedStartTime: false,
      openExpectedEndTime: false,
      openDeliveryStartTime: false,
      openDeliveryEndTime: false,
      orderType: undefined,
      orderNumber: undefined,
      itemsCount: undefined,
      vehicleType: undefined,
      date: undefined,
      startPickUpTime: undefined,
      endPickUpTime: undefined,
      startDeliveryTime: undefined,
      endDeliveryTime: undefined,
      deliveryCost: undefined,
      codAmount: undefined,
      dispatcher: undefined,
      orderStatus: undefined,
      createdBy: undefined
    };

    this.baseState = clone(this.state);
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  componentDidMount() {
    this.dragPreview = createDragPreview(formatDragMessage(this.props.selectedOrders.length), dragPreviewStyle);
    this.props.connectDragPreview(this.dragPreview);
  }

  componentDidUpdate(prevProps) {
    this.dragPreview = createDragPreview(formatDragMessage(this.props.selectedOrders.length), dragPreviewStyle, this.dragPreview);
  }

  handleResetFilter() {
    document.getElementsByName("reportsDateFilterEnd")[0].value='';
    this.pickUpStartTimeInput.setValue('');
    this.pickUpEndTimeInput.setValue('');
    this.deliveryStartTimeInput.setValue('');
    this.deliveryEndTimeInput.setValue('');
    this.baseState.date = undefined;
    this.props.clearSelectedOrders();
    this.setState(this.baseState);
  }

  handleOrderIdChange(id) {
    this.setState({orderNumber: id});
  }

  handleCreatedByChange(name) {
    this.setState({createdBy: name});
  }

  handleDateFilterChange(date) {

    if (date === 'Invalid date' || !date) {
      this.setState({date: undefined});
      return true;
    }

    this.setState({date: date});
  }
	
	handleDateFilterChangeRequest(date) {
		
		if (date === 'Invalid date' || !date) {
			this.setState({date: undefined});
			return true;
		}
		this.setState({date: date});
		this.props.getFilterOrdersForCompany(this.props.company.id, date);
	}

  handleItemCount(count) {
    this.setState({itemsCount: parseInt(count)});
  }

  toggleOpenExpectedTime(type) {
    if(type==='start')
      this.setState({
        openExpectedStartTime: !this.state.openExpectedStartTime
      });
    else
    this.setState({
      openExpectedEndTime: !this.state.openExpectedEndTime
    });
  }

  toggleOpenDeliveryTime(type) {
    if(type==='start')
      this.setState({
        openDeliveryStartTime: !this.state.openDeliveryStartTime
      });
    else
    this.setState({
      openDeliveryEndTime: !this.state.openDeliveryEndTime
    });
  }

  handlePickUpTimeFilterChange(timeVal, type) {
    if (type === 'startPickUpTime' && timeVal!=='') {
      this.setState({
        openExpectedStartTime: false,
        startPickUpTime: timeVal._d.getHours() + ':00'
      });
    }

    if (type === 'endPickUpTime' && timeVal!=='') {
      this.setState({
        openExpectedEndTime: false,
        endPickUpTime: timeVal._d.getHours() + ':00'
      });
    }
  }

  handleOrderTypeChange(type) {
    if (!type || type === gettext('ALL')) {
      this.setState({orderType: undefined});
      return true;
    }

    this.setState({orderType: type});
  }

  handleOrderStatusChange(status) {
    if (status === gettext('ALL')) {
      this.setState({orderStatus: undefined});
      return true;
    }

    this.setState({orderStatus: status});
  }

  handleOrderCostChange(val) {
    this.setState({deliveryCost: parseInt(val)});
  }

  handleOrderCashAmount(val) {
    this.setState({codAmount: parseInt(val)});
  }

  handleDeliveryTimeFilterChange(timeVal, type) {
    if (type === 'startDeliveryTime' && timeVal!=='') {
      this.setState({
        openDeliveryStartTime: false,
        startDeliveryTime: timeVal._d.getHours() + ':00'
      });
    }

    if (type === 'endDeliveryTime' && timeVal!=='') {
      this.setState({
        openDeliveryEndTime: false,
        endDeliveryTime: timeVal._d.getHours() + ':00'
      });
    }
  }

  handleVehicleFilterChange(type) {
    if (type === gettext('ALL')) {
      this.setState({vehicleType: undefined});
      return true;
    }

    this.setState({vehicleType: parseInt(type)});
  }

  handleDispatcherChange(val) {
    this.setState({dispatcher: val});
  }

  render() {
    const { handleOrderSelectChange, selectedOrders, filterOrders } = this.props;
    var orders = _.orderBy(orders, ['createdAt'], ['desc']);
      orders = Filters.filterByStatus(filterOrders && filterOrders.length > 0 ? filterOrders : this.props.orders, this.state.orderStatus);
      orders = this.props.orderListViewMode!=='orderHistory'
                ?Filters.filterByDate(orders, this.state.date)
                :Filters.filterByDateOrderHistory(orders, this.state.date);
      orders = Filters.filterByExpectedPickupTime(orders, this.state.startPickUpTime, this.state.endPickUpTime);
      orders = Filters.filterByOrderType(orders, this.state.orderType);
      orders = Filters.filterByDeliveryTime(orders, this.state.startDeliveryTime, this.state.endDeliveryTime);
      orders = Filters.filterByVehicleType(orders, this.state.vehicleType);
      orders = Filters.filterByDeliveryCommission(orders, this.state.deliveryCost);
      orders = Filters.filterByCodAmount(orders, this.state.codAmount);
      orders = Filters.filterCreatedBy(orders, this.state.createdBy);
      orders = Filters.filterByOrderId(orders, this.state.orderNumber);
      orders = Filters.filterByItemCount(orders, this.state.itemsCount);
      orders = Filters.filterByDriver(orders, this.props.drivers, this.state.driver);



    const vehiclesFilter = _.map(this.props.vehicles, (vehicle, i) => (
      <option key={`vehicle_${vehicle.type}${i}`} value={vehicle.size}>
        {firstToUpper(vehicle.type)}
      </option>
    ));

    let columnsForThisTableType;

    if(this.props.orderListViewMode==='orders')
      columnsForThisTableType = columnsNewOrders;
    else if(this.props.orderListViewMode==='assignedOrders')
      columnsForThisTableType = columnsProgress;
    else if(this.props.orderListViewMode==='orderHistory')
      columnsForThisTableType = columnsHistory;
    const tableRows = _(orders).sortBy('createdAt').reverse()
      .map((order) => {
        const { id } = order;
        const isOrderSelected = _.includes(selectedOrders, order);
        const className = isOrderSelected ? 'highlighted' : '';
        const platform = (order.createdByPlatformId)
          ? _.find(this.props.users, { id: order.createdByPlatformId })
          : undefined;
        if (platform) {
          order['platform'] = platform;
        }
        return (
          <Tr
            key={`order_${id}`}
            className={className}
            onClick={(e) => handleOrderSelectChange(order, e)}
            draggable="true"
            onDragStart={(e) => this.props.startDraggingOrder(order)}>

              <Td key={order.id} column={gettext('ORDER-#')} className={order.express ? 'red_border' : ''}>
                <div>
                  <Button
                    className={getDashboardButtonStyle(order)}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.props.renderModalForDetails(order);
                    }}>
                    {order.id.slice(order.id.length - 5, order.id.length)}
                  </Button>
                </div>
              </Td>

            {_.map(columnsForThisTableType, (c, i) => (
              <Td key={i} column={c.title} className={order.express ? 'red_border' : ''}>
                {c.id === 'status'
                  ?<span style={setOrderStatusColor(order.orderStatus)}>{c.render(order, this.props)}</span>
                  :<span>{c.render(order, this.props)}</span>
                }
              </Td> ))
            }

          </Tr>
        );
      })
      .value();
    return this.props.connectDragSource(
      <div className="dispatcherDashboardPageOrdersTableContainer">
          <OverlayTrigger placement={getCurLang() === 'ar'?'right':'left'} overlay={getTooltip(gettext('RESET-FILTER'))}>
          <div className="clear_btn_container">

            <Button className="remove_filter_btn"
              onClick={() => this.handleResetFilter()}>
                &#x2716;
            </Button>
            </div>

          </OverlayTrigger>
        <Table
          dir={getCurLang() === 'ar' ? 'rtl' : 'ltr'}
          className="dispatcherDashboardPageOrdersTable"
          itemsPerPage={15}
          previousPageLabel={gettext('NAV-PREVIOUS')}
          nextPageLabel={gettext('NAV-NEXT')}
          pageButtonLimit={5}
          noDateText={gettext('NOTHING-TO-SHOW')}
          onPageChange={(e) =>{
            if(this.props.historyPageCount && (this.props.historyPageCount - e) <= 1) {
              this.props.startSpinner();
              this.props.addSomeOrdersToHistory(this.props.company.id, this.props.lowerProcessedAtTime);
            }
          }}>

          <Thead>
            <Th column={gettext('ORDER-#')}>
              <label title={gettext('ORDER-#')}>{gettext('ORDER-#')}</label>
              <div className="order_filter">
                <FormControl
                  componentClass="select"
                  className={`order_type_select ${this.state.orderType}`}
                  onChange={(e) => this.handleOrderTypeChange(e.target.value)}>
                    <option value={gettext('ALL')}>  {gettext('ALL')}  </option>
                    <option value="isOutOfCity"> {firstToUpper(gettext('OUT-OF-CITY'))} </option>
                    <option value="express"> {firstToUpper(gettext('EXPRESS-DELIVERY'))} </option>
                    <option value="regular"> {firstToUpper(gettext('REGULAR'))} </option>
                </FormControl>
                <input type="text" className="form-control" name="id"
                  onChange={(e) =>this.handleOrderIdChange(e.target.value)} onClick={this.stopPropagation}
                  value={this.state.orderNumber?this.state.orderNumber:''}/>
              </div>
            </Th>
            <Th column={gettext('#-OF-ITEMS')}>
              <label title={gettext('#-OF-ITEMS')}>{gettext('#-OF-ITEMS')}</label>
              <input type="text" className="form-control" name="items"
                onChange={(e) =>this.handleItemCount(e.target.value)} onClick={this.stopPropagation}
                value={this.state.itemsCount?this.state.itemsCount:''}/>
            </Th>
            <Th column={gettext('VEHICLE-TYPE')}>
              <label title={gettext('VEHICLE-TYPE')}>{gettext('VEHICLE-TYPE')}</label>
              <FormControl
                componentClass="select"
                onChange={(e) => this.handleVehicleFilterChange(e.target.value)}
                value={this.state.vehicleType?this.state.vehicleType:gettext('ALL')}>
                  <option value={gettext('ALL')}>  {gettext('ALL')}  </option>
                  {vehiclesFilter}
              </FormControl>
            </Th>
            <Th column={gettext('PICKUP-TIME')}>
              <label title={gettext('PICKUP-TIME')}>{gettext('PICKUP-TIME')}</label>
              <TimePicker
                className="xxx"
                showMinute={false}
                ref={(input) => { this.pickUpStartTimeInput = input; }}
                showSecond={false}
                onClick={() => this.toggleOpenExpectedTime('start')}
                open={this.state.openExpectedStartTime}
                onOpen={() =>this.setState({ openExpectedStartTime: true })}
                onChange={(event) => {this.handlePickUpTimeFilterChange(event, 'startPickUpTime');}}
              />
              -
               <TimePicker
                className="xxx"
                showMinute={false}
                showSecond={false}
                ref={(input) => { this.pickUpEndTimeInput = input; }}
                onClick={() => this.toggleOpenExpectedTime('end')}
                open={this.state.openExpectedEndTime}
                onOpen={() =>this.setState({ openExpectedEndTime: true })}
                onChange={(event) => this.handlePickUpTimeFilterChange(event, 'endPickUpTime')}
              />
            </Th>
            <Th column={gettext('DELIVERY-TIME')}>
              <label title={gettext('DELIVERY-TIME')}>{gettext('DELIVERY-TIME')}</label>
              <TimePicker
                className="xxx"
                showMinute={false}
                showSecond={false}
                ref={(input) => { this.deliveryStartTimeInput = input; }}
                onClick={() => this.toggleOpenDeliveryTime('start')}
                open={this.state.openDeliveryStartTime}
                onOpen={() =>this.setState({ openDeliveryStartTime: true })}
                onChange={(event) => this.handleDeliveryTimeFilterChange(event, 'startDeliveryTime')}
              />
              -
               <TimePicker
                className="xxx"
                showMinute={false}
                showSecond={false}
                ref={(input) => { this.deliveryEndTimeInput = input; }}
                onClick={() => this.toggleOpenDeliveryTime('end')}
                open={this.state.openDeliveryEndTime}
                onOpen={() =>this.setState({ openDeliveryEndTime: true })}
                onChange={(event) => this.handleDeliveryTimeFilterChange(event, 'endDeliveryTime')}
              />
            </Th>
            <Th column={gettext('DATE')}>

              <label title={gettext('DATE')}>{this.props.orderListViewMode!=='orderHistory'?gettext('PICKUP-DATE'):gettext('PROCESSED-DATE')}</label>

              <DateTimeField
                mode="date"
                viewMode="days"
                name="endDeliveryTime"
                inputFormat="MM/DD/YYYY"
                value={this.state.date ? this.state.date : ''}
                dateTime={this.state.date ? this.state.date: moment()}
                ref={(input) => { this.dateInput = input; }}

                inputProps={{
                  name: "reportsDateFilterEnd",
                  className: "form-control filter_input"
                }}
                onChange={(event) => {
                  this.handleDateFilterChangeRequest(event);
                }} />
            </Th>
            <Th column={gettext('DELIVERY-COST')}>
              <label title={gettext('DELIVERY-COST')}>{gettext('DELIVERY-COST')}</label>
              <input type="text" className="form-control" name="deliveryCommission"
                onChange={(e) => this.handleOrderCostChange(e.target.value)} onClick={this.stopPropagation}
                value={this.state.deliveryCost?this.state.deliveryCost:''}/>
            </Th>
            <Th column={gettext('CASH-ON-DELIVERY')}>
              <label title={gettext('CASH-ON-DELIVERY')}>{gettext('CASH-ON-DELIVERY')}</label>
              <input type="text" className="form-control" name="cashOnDeliveryAmount"
                onChange={(e) => this.handleOrderCashAmount(e.target.value)} onClick={this.stopPropagation}
                value={this.state.codAmount?this.state.codAmount:''}/>
            </Th>
            <Th column={gettext('CREATED-BY')}>
              <label title={gettext('CREATED-BY')}>{gettext('CREATED-BY')}</label>
              <input type="text" className="form-control" name="dispatcherId"
                onChange={(e) => this.handleCreatedByChange(e.target.value)} onClick={this.stopPropagation}
                value={this.state.createdBy?this.state.createdBy:''}/>
            </Th>
            <Th className={this.props.orderListViewMode==='orders'?'display_none':''} column={gettext('STATUS')}>
              <label title={gettext('STATUS')}>{gettext('STATUS')}</label>
              <FormControl
                componentClass="select"
                onChange={(e) => this.handleOrderStatusChange(e.target.value)}
                value={this.state.orderStatus?this.state.orderStatus:gettext('ALL')}
                className={this.props.orderListViewMode === 'orders'
                            ?'visibility_hidden':'order_type_select'}>
                <option value={gettext('ALL')}>  {gettext('ALL')}  </option>
                {
                  _.map(_.uniqBy(this.props.orders, 'orderStatus'), function (item, i) {
                    return <option key={i} value={item.orderStatus}>{formatCamelCase(gettext('STATUS.'+item.orderStatus.toUpperCase()))}</option>;
                  })
                }
              </FormControl>
            </Th>
            <Th className={this.props.orderListViewMode==='orders'?'display_none':''} column={gettext('DRIVER')}>
              <label title={gettext('DRIVER')}>{gettext('DRIVER')}</label>
              <input type="text" className="form-control" name="driver"
                value={this.state.driver?this.state.driver:''}
                onChange={(e) => this.setState({driver: e.target.value})}/>
            </Th>
          </Thead>

          {tableRows}

        </Table>
        {this.state.modal}
      </div>
    );
  }
}

OrdersList.propTypes = {
  users: PropTypes.array,
  orders: PropTypes.array,
  recipients: PropTypes.array,
  groupages: PropTypes.array,
  showOrderDetails: PropTypes.func,
  handleOrderSelectChange: PropTypes.func,
  selectedOrders: PropTypes.array.isRequired,
  vehicles: PropTypes.array.isRequired,
  deleteOrder: PropTypes.func,
  cancelOrder: PropTypes.func,
  loaded: PropTypes.bool,
  orderListPageNumber: PropTypes.number,
  saveCurrentPageOrderList: PropTypes.func,

  connectDragSource: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    drivers: state.dashboardPageReducer.drivers,
    filterOrders: state.appReducer.companyOrders
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getFilterOrdersForCompany: bindActionCreators(getFilterOrdersForCompany, dispatch)
  };
}

export default DragSource(ItemTypes.ORDER, orderSource, collect)(connect(
  mapStateToProps,
  mapDispatchToProps
)(OrdersList));



// WEBPACK FOOTER //
// ./src/components/orders/OperatorOrdersListComponent.js